<div class="searchForm flex-row" #myForm id="formMinAnnonce">
    <!-- <div class="form-row formTile">
        <div class="col-12"> </div>
    </div> -->
      
      <div class="form-row">
          <div class="col-2">
              <label  for="Description" >Statistiques : </label>
          </div>
          <div class="col-6">
              <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
              dropdownPosition='bottom' placeholder="Type De Place"
                [items]="statTypes" [multiple]="false"
                [bindLabel]="'name'"
                (change)="selectChange()"
                [closeOnSelect]="true" bindValue="name" [(ngModel)]="stattype"
                name="selectType">
              </ng-select>
          </div>
      </div>
                  
    
  </div>

<div style="display: block;">
    <canvas baseChart 
      [datasets]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions"
      [plugins]="barChartPlugins"
      [legend]="barChartLegend"
      [chartType]="barChartType">
    </canvas>
  </div>
  